module.exports = __webpack_public_path__ + "static/img/model-bg29.7c6133e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg29.jpg
// module id = cr50
// module chunks = 0